module.exports = __webpack_public_path__ + "static/media/joinedTournaments_250_500.857eaad4.png";